import type { FaireProductEntity } from "../../entity_types/product";

export const p_sdbf77265f: FaireProductEntity = {
  token: "p_sdbf77265f",
  type: "product",
  name: "Chevron Ruben Tee - Lobelia",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/2520cf870af600ea36c4b528d5a8295b1a12df813ad1d8d45ad5aa78c57bcb6c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ca1326de6e3fddf3156679f2ede66d64b4936c04d72b4165a6fde28552599a24.jpeg",
    "https://cdn.faire.com/fastly/d2141f689e8f96e45e2566efeb790970174e46a5edbcfdd8eebef8dd2c5f3a4f.jpeg",
    "https://cdn.faire.com/fastly/20abae949276f37b99cbb17fdacf5b791e41a84890bc40cd9803558cc5fc0dd5.jpeg",
    "https://cdn.faire.com/fastly/6877ef4e448cff2f3b50340b18225787fc0183ec81b1f212abea69f005626aa8.jpeg",
    "https://cdn.faire.com/fastly/ed5c8e0ca4105366933a6222364a43292d51807861605ffff7bdfe41bb2a2504.jpeg"
  ],
  priceDollars: 71.1,
  description: "The Chevron Ruben Tee carries a relaxed shape that sits cleanly through the shoulders and adapts easily across different body types. The set-in sleeve creates a more defined line, while the ribbed chevron structure brings quiet texture and dimension to an otherwise minimal form. It wears easily on its own or layered under cardigans and jackets. The chevron pattern adds just enough visual rhythm to elevate everyday styling, pairing naturally with denim, skirts, or shorts.\n\n * Midweight 100% cotton with a soft feel \n * Vintage-inspired relaxed fit \n * Set-in shoulder sleeve that adapts well from narrow to broad shoulders \n * Ribbed chevron knit adds texture, movement, and subtle dimension \n * Pairs well with jeans, skirts, or shorts \n * Works well on its own or layered under cardigans and jackets ",
  tags: [],
  msrpDollars: 158,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:32.016Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
